/** @jsx jsx */
// @ts-check
import { Box, Container } from '@bottlebooks/gatsby-theme-base';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { graphql } from 'gatsby';
// @ts-ignore Ignore default export error for lodash/shuffle.
import shuffle from 'lodash/shuffle';
// @ts-ignore Ignore default export error for React.
import React from 'react';
import { jsx } from 'theme-ui';
import { resolve } from '../../helpers/path';
import EventBanner from '../Event/EventBanner';
import EventHeader from '../Event/EventHeader';
import Layout from '../Layout';
import SEO from '../seo.js';
import FeaturedExhibitorsSection from './FeaturedExhibitorsSection';
import FeaturedProducersSection from './FeaturedProducersSection';
import SiteSearch from './SiteSearch';

export default function LandingPage({
  event,
  exhibitors,
  producers,
  location,
  paths,
  segments,
  locale,
  withOverlay,
}) {
  const shuffledExhibitors = React.useMemo(
    () => shuffle(exhibitors).slice(0, 8),
    [exhibitors]
  );
  const shuffledProducers = React.useMemo(
    () => shuffle(producers).slice(0, 8),
    [producers]
  );
  const { i18n } = useLingui();

  return (
    <Layout paths={paths} locale={locale} sx={{ backgroundColor: 'light' }}>
      <SEO page={{ path: location.href }} />
      <EventBanner event={event} withOverlay={withOverlay} />
      <Container>
        <Box
          sx={{
            transform: 'translateY(-50%)',
            position: 'relative',
            zIndex: 'modal',
          }}
        >
          <SiteSearch
            variant="largest"
            locale={locale}
            sx={{ boxShadow: 'overlay', backgroundColor: 'white' }}
            placeholder={i18n._(t`Search for producer, wine or region…`)}
            paths={paths}
            getExhibitorLink={({ slug }) => resolve([paths.exhibitors, slug])}
            getProductLink={({ slug, exhibitor }) =>
              resolve([
                paths.exhibitors,
                exhibitor?.slug,
                segments?.product || paths?.product,
                slug,
              ])
            }
          />
        </Box>
      </Container>
      <Container sx={{ paddingY: [4, 5] }}>
        <EventHeader event={event} />
      </Container>
      {Boolean(exhibitors?.length) && (
        <FeaturedExhibitorsSection
          exhibitors={shuffledExhibitors}
          exhibitorsPath={paths.exhibitors}
        />
      )}
      {Boolean(producers?.length) && (
        <FeaturedProducersSection
          producers={shuffledProducers}
          producersPath={paths.producers}
        />
      )}
    </Layout>
  );
}

export const fragment = graphql`
  fragment LandingPage_FeaturedExhibitors on Exhibitor {
    ...FeaturedExhibitorsSection
  }

  fragment LandingPage_Map on AbstractBrand {
    name
    slug
    latitude
    longitude
  }
  fragment LandingPage on Event {
    ...EventBanner
    ...EventHeader
  }
`;
